// Frontend Application Constants

// Set via APP_VERSION in the repo root .env (shared with the backend); bump on every deployment.
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_VERSION_STORAGE_KEY = 'smartmirror_app_version';

// Set per environment in frontend/.env.local / .env.dev / .env.prod, selected by APP_ENV in the repo root .env.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ROUTES = {
  // Public Routes
  QR_LOGIN: '/qr-login',
  MOBILE_WELCOME: '/mobile-welcome',
  MOBILE_LOGIN: '/mobile-login',
  OTP_VERIFICATION: '/otp-verification',
  PROFILE_SETUP: '/profile-setup',
  ACCOUNT_DEREGISTER: '/account/delete',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  ADMIN_LOGIN: '/admin/login',

  // Customer Routes
  WELCOME: '/welcome',
  DASHBOARD: '/dashboard',
  SERVICE_SELECT: '/services/select',
  SERVICE_CONFIRM: '/services/confirm',
  SERVICE_ENJOY: '/services/enjoy',
  SERVICE_ONGOING: '/services/ongoing',
  TRANSACTION_HISTORY: '/transactions/history',
  TRANSACTION_HISTORY_DETAIL: '/transactions/history/:bookingId',
  FEEDBACK: '/feedback',
  PAYMENT: '/payment',
  PAYMENT_CONFIRMATION: '/payment/confirmation',
  PHOTO_CAPTURE: '/photo-capture',

  // Admin Routes
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_BRANDS: '/admin/brands',
  ADMIN_SALONS: '/admin/salons',
  ADMIN_MIRRORS: '/admin/mirrors',
  ADMIN_CATEGORIES: '/admin/categories',
  ADMIN_SERVICES: '/admin/services',
  ADMIN_STYLISTS: '/admin/stylists',
  ADMIN_FEATURE_PACKS: '/admin/feature-packs',
  ADMIN_APPROVALS: '/admin/approvals',
  ADMIN_TRANSACTIONS: '/admin/transactions',
  ADMIN_TRANSACTION_DETAILS: '/admin/transactions/:transactionId',
  ADMIN_REPORTS: '/admin/reports',
  ADMIN_USERS: '/admin/users',
  ADMIN_FEEDBACK: '/admin/feedback',
  ADMIN_ONGOING_SERVICES: '/admin/ongoing-services',
  ADMIN_FEEDS: '/admin/feeds',
  ADMIN_PROMOTIONAL_FEEDS: '/admin/promotional-feeds',
  ADMIN_ENGAGEMENT_SERVICES: '/admin/engagement-services',

  // Kiosk (landscape web clone of the Android TV app)
  KIOSK: '/kiosk',
  KIOSK_SETTINGS: '/kiosk/settings',
  KIOSK_PORTAL: '/kiosk/portal',
  KIOSK_DISCOVERY: '/kiosk/discovery',
  KIOSK_CONFIRM: '/kiosk/confirm',
  KIOSK_PHOTO: '/kiosk/photo',
  KIOSK_FLOW: '/kiosk/flow',
  KIOSK_FEEDBACK: '/kiosk/feedback',
  KIOSK_PAYMENT: '/kiosk/payment',
  KIOSK_HISTORY: '/kiosk/history',
  KIOSK_HISTORY_DETAIL: '/kiosk/history/:bookingId',
  KIOSK_PROFILE: '/kiosk/profile',
  KIOSK_TRY_ON: '/kiosk/try-on',
  KIOSK_SKIN: '/kiosk/skin'
};

export const USER_ROLES = {
  CUSTOMER: 'customer',
  ADMIN: 'admin',
  BRANCHADMIN: 'branchadmin',
  BRANDADMIN: 'brandadmin',
  SUPERADMIN: 'superadmin'
};

export const BOOKING_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const LOYALTY_TIERS = {
  BRONZE: { name: 'Bronze', min: 0, max: 499, color: '#8189A5' },
  SILVER: { name: 'Silver', min: 500, max: 999, color: '#8189A5' },
  GOLD: { name: 'Gold', min: 1000, color: '#E29D38' }
};

/** Mobile web: browse only; service selection and booking happen on the mirror TV app. */
export const WEB_BOOKING_DISABLED = true;
export const WEB_TV_BOOKING_MESSAGE =
  'Service selection and booking are available on the mirror TV only. Please continue on the TV.';

/** Shown on mobile web when the mirror TV has an active customer session. */
export const TV_SESSION_BLOCK_MESSAGE =
  'Your session is active on the TV. Please use the TV to continue.';

/** Mobile web: show transaction history only; dashboard and services hidden for now.
 *  Set true to force all users (including first-time) to /transactions/history.
 *  Set false so first-time users can reach Welcome → Dashboard after profile setup. */
export const WEB_HISTORY_ONLY = false;

export const getCustomerHomeRoute = () =>
  WEB_HISTORY_ONLY ? ROUTES.TRANSACTION_HISTORY : ROUTES.DASHBOARD;
